export default {
    change_timezone_title: "Change Timezone",
    change_timezone_the_timezone_has_been_changed: "The timezone has been changed",
    change_timezone_it_was_possible_to_change_the_timezone: "It is not possible to change timezone",
    change_timezone_device_name: "Device Name",
    change_timezone_timezone: "Timezone",
    change_timezone_warning_timezone: "Some of the selected devices already have this timezone",
    change_timezone_change: "Change",
    change_timezpne_transaction_message: "The request to change the timezone has been sent successfully, please check the transactions list to see the status of the request.",
};
